module.exports = __webpack_public_path__ + "static/Vilma_Sabaliauskiene-eeffbbb18fb2e0748c38d71a049e5a7b.jpg";